/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: kp0OkUEgiTwF

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import Button from "../../Button"; // plasmic-import: In8OlLBJG380/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicCalloutSectionTextColumn.module.css"; // plasmic-import: kp0OkUEgiTwF/css

import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: kE4-BqL_BWFR/icon

createPlasmicElementProxy;

export type PlasmicCalloutSectionTextColumn__VariantMembers = {};
export type PlasmicCalloutSectionTextColumn__VariantsArgs = {};
type VariantPropType = keyof PlasmicCalloutSectionTextColumn__VariantsArgs;
export const PlasmicCalloutSectionTextColumn__VariantProps =
  new Array<VariantPropType>();

export type PlasmicCalloutSectionTextColumn__ArgsType = {
  onContactClick?: () => void;
};
type ArgPropType = keyof PlasmicCalloutSectionTextColumn__ArgsType;
export const PlasmicCalloutSectionTextColumn__ArgProps = new Array<ArgPropType>(
  "onContactClick"
);

export type PlasmicCalloutSectionTextColumn__OverridesType = {
  col?: Flex__<"div">;
  header?: Flex__<"header">;
  heading?: Flex__<"h2">;
  text?: Flex__<"p">;
  actions?: Flex__<"div">;
  button?: Flex__<typeof Button>;
  button2?: Flex__<typeof Button>;
};

export interface DefaultCalloutSectionTextColumnProps {
  onContactClick?: () => void;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicCalloutSectionTextColumn__RenderFunc(props: {
  variants: PlasmicCalloutSectionTextColumn__VariantsArgs;
  args: PlasmicCalloutSectionTextColumn__ArgsType;
  overrides: PlasmicCalloutSectionTextColumn__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"col"}
      data-plasmic-override={overrides.col}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.col
      )}
    >
      <header
        data-plasmic-name={"header"}
        data-plasmic-override={overrides.header}
        className={classNames("all", sty.header)}
      >
        <h2
          data-plasmic-name={"heading"}
          data-plasmic-override={overrides.heading}
          className={classNames(
            "all",
            "h2",
            "h2__bvRZj",
            "__wab_text",
            sty.heading
          )}
        >
          {"Start the Conversation"}
        </h2>
        <p
          data-plasmic-name={"text"}
          data-plasmic-override={overrides.text}
          className={classNames("all", "p", "p__bvRZj", "__wab_text", sty.text)}
        >
          {
            "Every institution has unique goals, challenges, and opportunities.\r\nDiscover how MyEvaluations helps you achieve Better Assessments. Better Insight. Better Decisions through Continuous Educational Improvement."
          }
        </p>
      </header>
      <div
        data-plasmic-name={"actions"}
        data-plasmic-override={overrides.actions}
        className={classNames("all", sty.actions)}
      >
        <Button
          data-plasmic-name={"button"}
          data-plasmic-override={overrides.button}
          aria-label={"Request demo"}
          className={classNames("__wab_instance", sty.button)}
          color={"primary"}
          link={
            "https://calendly.com/dmelamed/request-a-demo?hide_event_type_details=1&hide_gdpr_banner=1&primary_color=087fb3"
          }
          size={
            hasVariant(globalVariants, "mobile", "mobileXSmall")
              ? "medium"
              : "large"
          }
          target={true}
        >
          <div className={classNames("all", "__wab_text", sty.text__pGDx)}>
            {"Request Personalized Demo"}
          </div>
        </Button>
        <Button
          data-plasmic-name={"button2"}
          data-plasmic-override={overrides.button2}
          aria-label={"Open contact modal"}
          className={classNames("__wab_instance", sty.button2)}
          color={"sky"}
          onClick={async event => {
            const $steps = {};

            $steps["runOnContactClick"] = true
              ? (() => {
                  const actionArgs = { eventRef: $props["onContactClick"] };
                  return (({ eventRef, args }) => {
                    return eventRef?.(...(args ?? []));
                  })?.apply(null, [actionArgs]);
                })()
              : undefined;
            if (
              $steps["runOnContactClick"] != null &&
              typeof $steps["runOnContactClick"] === "object" &&
              typeof $steps["runOnContactClick"].then === "function"
            ) {
              $steps["runOnContactClick"] = await $steps["runOnContactClick"];
            }
          }}
          size={
            hasVariant(globalVariants, "mobile", "mobileXSmall")
              ? "medium"
              : "large"
          }
        >
          <div className={classNames("all", "__wab_text", sty.text__wsCq3)}>
            {"Contact"}
          </div>
        </Button>
      </div>
      <Button
        className={classNames("__wab_instance", sty.button__bo8Fw)}
        color={"sky"}
        size={"large"}
      >
        <div className={classNames("all", "__wab_text", sty.text__cjyfa)}>
          {"CONTACT\n"}
        </div>
      </Button>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  col: ["col", "header", "heading", "text", "actions", "button", "button2"],
  header: ["header", "heading", "text"],
  heading: ["heading"],
  text: ["text"],
  actions: ["actions", "button", "button2"],
  button: ["button"],
  button2: ["button2"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  col: "div";
  header: "header";
  heading: "h2";
  text: "p";
  actions: "div";
  button: typeof Button;
  button2: typeof Button;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicCalloutSectionTextColumn__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicCalloutSectionTextColumn__VariantsArgs;
    args?: PlasmicCalloutSectionTextColumn__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicCalloutSectionTextColumn__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicCalloutSectionTextColumn__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicCalloutSectionTextColumn__ArgProps,
          internalVariantPropNames:
            PlasmicCalloutSectionTextColumn__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicCalloutSectionTextColumn__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "col") {
    func.displayName = "PlasmicCalloutSectionTextColumn";
  } else {
    func.displayName = `PlasmicCalloutSectionTextColumn.${nodeName}`;
  }
  return func;
}

export const PlasmicCalloutSectionTextColumn = Object.assign(
  // Top-level PlasmicCalloutSectionTextColumn renders the root element
  makeNodeComponent("col"),
  {
    // Helper components rendering sub-elements
    header: makeNodeComponent("header"),
    heading: makeNodeComponent("heading"),
    text: makeNodeComponent("text"),
    actions: makeNodeComponent("actions"),
    button: makeNodeComponent("button"),
    button2: makeNodeComponent("button2"),

    // Metadata about props expected for PlasmicCalloutSectionTextColumn
    internalVariantProps: PlasmicCalloutSectionTextColumn__VariantProps,
    internalArgProps: PlasmicCalloutSectionTextColumn__ArgProps
  }
);

export default PlasmicCalloutSectionTextColumn;
/* prettier-ignore-end */
